import "./Watch.css";
import React, { useState } from "react";
import axios from "axios";
function Watch() {
  const [data, setData] = useState([]);

  const acceptdata = () => {
    const options = {
      method: "GET",
      url: "https://movies-api14.p.rapidapi.com/shows",
      headers: {
        "X-RapidAPI-Key": "921ba5b9b5msh3e5ab7a94ad0dc5p108eb8jsnd74af4c0acf7",
        "X-RapidAPI-Host": "movies-api14.p.rapidapi.com",
      },
    };

    axios
      .request(options)
      .then((res) => {
        console.log(res.data);
        setData(res.data.movies);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div>
      {/* ========== Card ============ */}
      <div className="container-fluid pt-3" id="wback">
        <h2 className="text-white" id="mm">
         Watch For Free : <span className="text-primary">MOVIE MANIA</span>
        </h2>
        <button
          className="btn btn-info px-5 d-block mx-auto"
          onClick={acceptdata}
        >
          CLICK FOR MORE MOVIE
        </button>

        <div className="row">
          {data.map((val, key) => (
            <div className="col-12 col-xl-3 col-md-4" key={key}>
              <div className="card mb-5 mt-5 text-white" id="hcard">
                <img
                  src={val.backdrop_path}
                  className="card-img-top img-fluid"
                  alt="..."
                  id="mimg"
                />
                <div className="card-body" id="cbody">
                  <div className="row" id="iconup">
                    <div className="col-6">
                      <i className="fas fa-arrow-left text-white"></i>
                    </div>
                    <div className="col-6 text-end">
                      <i className="far fa-heart text-white"></i>
                    </div>
                  </div>
                  <div id="bottomtit">
                    <h5 className="card-title" id="">
                      <span className="text-dark">Title : </span> {val.original_title}
                    </h5>
                    <p className="card-text"><span className="text-dark">Sub_Title : </span>{val.title}</p>
                    <p><span className="text-dark">Genres : </span>{val.genres}</p>
                    <p><span className="text-dark">Overview : </span>{val.overview}</p>
                    <i class="fas fa-star text-warning"></i>
                    <i class="fas fa-star text-warning ms-1"></i>
                    <i class="fas fa-star text-warning ms-1"></i>
                    <i class="fas fa-star text-warning ms-1 me-1"></i>
                    <i class="fas fa-star"></i>
                  </div>
                  {/* <i class="fa-solid fa-arrow-left"></i> */}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
export default Watch;
